
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/high-school/[id]",
      function () {
        return require("private-next-pages/high-school/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/high-school/[id]"])
      });
    }
  